import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/** Shimmer frame behind progressive images until the inner img is loaded. */
@Component({
  selector: 'app-media-slot',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './media-slot.component.html',
  styleUrls: ['./media-slot.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaSlotComponent {
  @Input() fit: 'contain' | 'cover' = 'contain';
  @Input() rounded = true;
}
